import getApi from '../../../api/apisauceConfig'
import type { TrustedSource } from '../../../model/TrustedSource'

export const getTrustedSources = () => getApi().get<TrustedSource[]>('/trusted_sources')
